// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_ly-5";
export var filledCircle = "_ly-4";
export var historyEntry = "_ly-3";
export var messageSideLeft = "_ly-1";
export var messageSideRight = "_ly-2";
export var orderTrackingCarouselWrapper = "_ly-6";
export var orderTrackingInfoContainer = "_ly-0";